/**
 * Publication auth helpers (M10): real accounts sync to the server; anonymous plays local-only.
 */

export function isGuestUser(user) {
  if (!user || typeof user !== 'object') return false;
  return user.is_guest === true || user.account_kind === 'guest';
}

export function readStoredAuthUser() {
  if (typeof localStorage === 'undefined') return null;
  const raw = localStorage.getItem('auth_user');
  if (!raw) return null;
  try {
    return JSON.parse(raw);
  } catch {
    return null;
  }
}

/** True when a non-guest JWT session is present (account sync path). */
export function hasRealAccountSession() {
  if (typeof localStorage === 'undefined') return false;
  if (!localStorage.getItem('auth_token')) return false;
  const user = readStoredAuthUser();
  if (!user) return false;
  return !isGuestUser(user);
}

export function clearAuthSession() {
  if (typeof localStorage === 'undefined') return;
  localStorage.removeItem('auth_token');
  localStorage.removeItem('auth_user');
}
